import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import Layout from '../Layout/index';
import MainWrapper from './MainWrapper';
import { connect } from 'react-redux';

import LogIn from '../LogIn/index';
import Buildings from '../Buildings/index';
import ComingSoon from '../ComingSoonBuildings/index';
import BuildingAdmin from '../BuildingAdministration/index';
import RentalBuildingAdmin from '../RentalBuildingAdministration/index';
import HouseAdmin from '../Houses/index';
import PropertySearch from '../PropertySearch/index';
import BuildingsUnified from '../BuildingsUnified/index';
import InventoryUnified from '../InventoryUnified/index';

import SingleBuilding from '../SingleBuilding/index';
import BuildingDetailPage from '../BuildingDetail/components/SingleBuilding';
import Units from '../Units/index';
import BuyersLists from '../BuyersLists/index';
import SingleUnit from '../SingleUnit/index';
import SavedUnits from '../BuyersLists/components/SavedUnits/index';
import Dashboard from '../Dashboard/index';
import Analysis from '../Analysis/index';
import BuyerLeads from '../Dashboard/components/BuyerLeads/index';
import News from '../News/index';
import TransactionCenter from '../TransactionCenter/index';
import KnowledgeCenter from '../KnowledgeCenter/index';
import MarketingCenter from '../MarketingCenter/index';

import DataExport from '../DataExport/index';
import Sales from '../Sales/index';
import MyReports from '../MyReports/index';
import MyGroups from '../MyGroups/index';

import NewDevSales from '../NewDevSales/index';
import ListingAnalysis from '../ListingAnalysis/index';
import DiscountAnalysis from '../DiscountAnalysis/index';
import PriceAnalysis from '../PriceAnalysis/index';

import MarketActivity from '../MarketActivity/index';
import SalesVelocity from '../SalesVelocity/index';

import Developers from '../Developers/index';
import Architects from '../Architects/index';
import Lenders from '../Lenders/index';

import Pipeline from '../Pipeline/index';

import Profile from '../Profile/index';
import Billing from '../Billing/index';

import MarketAnalysis from '../MarketAnalysis/index';
import SharePage from '../SharePage/index';

import InventoryTrends from '../InventoryTrends/index';


import SingleUnitShare from '../SingleUnit/components/Share/index';
import SingleBuildingShare from '../SingleBuilding/components/Share/index';

import PropertyMap from "../PropertyMap/index";


import { Security, LoginCallback } from '@okta/okta-react';
import { withOktaAuth } from '@okta/okta-react';
import { setUserProfile } from '../../redux/actions/authActions';
import buyersListActions from '../../redux/actions/buyersListActions';

import Home from '../../shared/components/auth/okta/Home';
import OktaLogin from '../../shared/components/auth/okta/Login';

import Shareables from '../Marketing/Shareables/index';

import Beta from '../Beta/index';
import OwnerOutreach from '../OwnerOutreach/index';
import ExpiredListings from '../ExpiredListings/index';
import ForeclosureSearch from '../ForeclosureSearch/index';
import AlertRunDetail from '../AlertRunDetail/index';
import BrokerOutreach from '../BrokerOutreach/index';
import LinearLoading from '../../shared/components/LinearLoading';

import SavedSkipTracesPage from '../../shared/components/skiptrace/SavedSkipTracesPage';


import{
	_axiosCall
} from '../../shared/helpers/apicalls';

import{
	_getUserSSO,
	_setSSOToken,
	_getSSOToken,
	_getMPUserSSO,
	_getSSOOrg
} from '../../shared/components/auth/sso/ssoutils';

import{
	setLocalStorage,
	getLocalStorage
} from '../../shared/helpers/utils';
import { _isNewDevSubscriber } from '../../shared/components/payment/plans';

import MarketPulse from '../MarketPulse/index';
const oktaToken = process.env.OKTA_TOKEN;

const onAuthRequired = ( props ) => {
	alert("auth required");
	//console.log(props);
  //history.push('/login');

  return <Redirect to={{ pathname: `/login`}} />

}

const config = {
  issuer: `https://${process.env.OKTA_DOMAIN}/oauth2/default`,
  redirectUri: window.location.origin + '/implicit/callback',
  clientId: `${process.env.OKTA_CLIENT_ID}`,
  onAuthRequired: onAuthRequired,
  pkce: true
};

const _getToken = () => {
	let ssoToken = _getSSOToken();
  	let type = "CBWarburg";
  	if(!ssoToken){
	 	ssoToken = _getSSOToken('MPSSO');
	 	if(ssoToken){
		 	type = "MPSSO";
	 	}
  	}
	return {ssoToken : ssoToken, type : type};
}

const Pages = () => (
  <Switch>
    <Route exact path="/" component={Dashboard} />
    <Route exact path="/buildings/:borough/:neighborhood/:building_slug" component={SingleBuilding} />
	<Route exact path="/buildings/:borough/:neighborhood/:building_slug/tab/:tab/:subtab/:subsubtab?" component={SingleBuilding} />
    <Route exact path="/buildings/:borough/:neighborhood/:building_slug/tab/:tab/:subtab?" component={SingleBuilding} />
  	<Route exact path="/buildings/:borough/:neighborhood/:building_slug/:unit" component={SingleUnit} />
  	<Route exact path="/buildings/:borough/:neighborhood/:building_slug/:unit/tab/:tab" component={SingleUnit} />

    <Route exact path="/building/:borough/:neighborhood/:building_slug" component={BuildingDetailPage} />
    <Route exact path="/building/:borough/:neighborhood/:building_slug/tab/:tab" component={BuildingDetailPage} />

	<Route path="/inventory/:stage?" component={Units} />
	<Redirect exact from="/building-database/house/multi-family" to="/buildings/multi-family" />
	<Route path="/building-database/house/:type?" component={HouseAdmin} />

    <Route exact path="/buildings/:segment(condos|rental|commercial|multi-family|vacant-land|other)" component={BuildingsUnified} />
    <Redirect exact from="/buildings/all" to="/buildings/other" />
    <Route path="/buildings" component={Buildings} />
    <Route path="/coming-soon" component={ComingSoon} />
    <Redirect exact from="/building-database/sale/:stage" to="/buildings/condos" />
    <Redirect exact from="/building-database/sale" to="/buildings/condos" />
    <Redirect from="/building-database/rental" to="/buildings/rental" />
	<Redirect from="/building-database/property-search" to="/buildings/other" />

	<Route path="/map" component={PropertyMap} />
    
    <Route path="/my-buildings" component={BuyersLists} />
    <Route path="/my-units" component={SavedUnits} />
    <Route path="/dashboard" component={Dashboard} />
    <Route path="/my-exports" component={DataExport} />
	<Route path="/my-shared" component={MyReports} />
	<Route path="/collections/:tab?" component={MyGroups} />
    <Route path="/news/:subtab?" component={News} />
    <Route path="/analysis/new-development" component={Analysis} />
	<Route path="/inventory-analysis" component={Analysis} />
	<Route path="/inventory-trends" component={InventoryTrends} />
    <Route path="/my-leads" component={BuyerLeads} />
    <Route path="/transaction-center" component={TransactionCenter} />
    <Route path="/community-center" component={KnowledgeCenter} />
	<Route path="/my-account/:type" component={Profile} />
    <Route path="/my-account" component={Profile} />
	
    <Route path="/my-subscription" component={Billing} />
	
	<Route path="/marketing-center" component={MarketingCenter} />
	
	<Route path="/beta-tools/:section" component={Beta} />
	<Route path="/owner-outreach" component={OwnerOutreach} />
	<Route path="/foreclosure-search" component={ForeclosureSearch} />
	<Route exact path="/expired-listings/runs/:runId" component={AlertRunDetail} />
	<Route exact path="/expired-listings/:tab?" component={ExpiredListings} />

	<Route path="/my-owners/:record_id" component={SavedSkipTracesPage} />
	<Route path="/my-owners" component={SavedSkipTracesPage} />
	<Route path="/broker-outreach" component={BrokerOutreach} />
    
    <Route path="/sales-agents" component={NewDevSales} />
    <Route path="/developers" component={Developers} />
    <Route path="/architects" component={Architects} />
    <Route path="/lenders" component={Lenders} />
    
    <Route path="/past-sales" component={Sales} />
    
    <Route path="/analysis/market-pulse" component={MarketActivity} />
	<Route path="/analysis/market-snapshots" component={MarketPulse} />
    
    <Route path="/analysis/sales-velocity" component={SalesVelocity} />
    
    <Route path="/analysis/market" component={MarketAnalysis} />
    
    <Route exact path="/analysis/discount" component={DiscountAnalysis} />
    <Route exact path="/analysis/discount/tab/:tab" component={DiscountAnalysis} />
    
    <Route exact path="/analysis/pricing" component={PriceAnalysis} />
    <Route exact path="/analysis/pricing/tab/:tab" component={PriceAnalysis} />
    
    <Route path="/filings" component={Pipeline} />
	
	<Route exact path="/private-report/:custom_link" component={SharePage} />
  </Switch>
);

class wrappedRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      fetchInProgress: false
    };
  }
  
  setBodyClassByUser(user) {
	if (!user || !Array.isArray(user.role)) return;
  
	// Clean up: remove any prior user-role classes
	const currentClasses = Array.from(document.body.classList);
	currentClasses
	  .filter(cls => cls.startsWith('role-'))
	  .forEach(cls => document.body.classList.remove(cls));
  
	// Add new role-based classes
	user.role.forEach(role => {
	  const safeRole = `role-${role.toLowerCase().replace(/\s+/g, '-')}`;
	  document.body.classList.add(safeRole);
	});
  }
  
  componentDidMount(){
	  const { authState, authService, dispatch, user, dataSet } = this.props;
	  const ssoToken = _getSSOToken();
	  
	   if (!ssoToken) {
	      // When user isn't authenticated, forget any user info
	      //setUserInfo(null);
	      dispatch(setUserProfile(null));
		  
	   } else if(ssoToken && ssoToken.access_token && !user){
			  console.log(ssoToken)
				 _getUserSSO(ssoToken, this.props, setUserProfile).then(() => {
					 
				  })

	  }
	  
	if (user) {
	  this.setBodyClassByUser(user);
	}
  }
  
  componentDidUpdate(prevProps, prevState, snapshot){
	  const { authState, authService, dispatch, dataSet, user } = this.props;
	  console.log(authState, authService, user);
	  
	  if (this.props.user !== prevProps.user && this.props.user) {
		  this.setBodyClassByUser(this.props.user);
		}
/*
	  if (!authState.isPending && !authState.isAuthenticated) {
	      // When user isn't authenticated, forget any user info
	      //setUserInfo(null);
	      dispatch(setUserProfile(null));
	   } else {
		   

		  if(!authState.isPending && !user){
			  authService.getUser().then((user) => {
	        
		        this._getUserOktaData(user);
		        if(!dataSet){
			        this._getUserMongoData(user); 
		        }
		         
		     }, error => {
			      console.error(error);
		      });
			  
		  }
	      

	  }
*/
  }
  

  
  _getUserMongoData = (user) => {
  		if(!user) return false;
        if (!this.state.fetchInProgress) {
		  this.setState(prevState => ({ fetchInProgress: true, }));
         }
      
        const { authState, authService, dispatch } = this.props;
      
		let axiosData = {
			url: `${process.env.API_ROOT}/buyerslist/userdata/${user.sub}`,
			method: "get"
		};

		 _axiosCall(axiosData)
			.then(res => {
				console.log('Data', res);
				if(res && res[0]){
					this.setState({ fetchInProgress : false });
					let mongoUser = Object.assign({}, res[0]);
					dispatch(buyersListActions.setUserData(mongoUser))
				}else{
					dispatch(buyersListActions.setUserData({}))
				}
			})
			.catch(error => {
				console.log("error: " + error);
			});

   }
  
  
  render(){	 
	  
	 	const { authService, authState, user, component, nochrome } = this.props;
		 

		
		const ssoOrg = _getSSOOrg();
			
		const ssoToken = _getSSOToken();	
		if ((ssoToken && !user)){
			return (
			<div className={`${ssoOrg === "ELLIMAN" ? "role-elliman-agent" : ""}`} style={{
			  display: 'flex',
			  flexDirection: 'column',
			  justifyContent: 'center',
			  alignItems: 'center',
			  width: '100vw',
			  height: '100vh',
			}}>
			  <div style={{ width: '100%', maxWidth: '1000px' }}>
				<LinearLoading />
			  </div>
			  {ssoOrg === "ELLIMAN" ?
			  <img
				  src="https://marketproof-hosting.s3.us-east-1.amazonaws.com/logos/MPxDE-lockup-dark.png"
				  alt="Marketproof Pro Logo"
				  style={{ marginTop: '20px', maxWidth: '500px', width: '100%' }}
				/>
			  
			  :
			  <img
				src="https://marketproof-hosting.s3.us-east-1.amazonaws.com/logos/marketproof-pro-logo.png"
				alt="Marketproof Pro Logo"
				style={{ marginTop: '20px', maxWidth: '300px', width: '100%' }}
			  />}
			</div>
			);
		} 
		if ((user && user.authType === 'sso')){		
			
			if(user === null) return null;
			if(user && !_isNewDevSubscriber(user)){
				return <Redirect to={{ pathname: "/payment" }} />
			}
			
			
			if(nochrome && component){
				return <div>{component}</div>;
			}
		
		  if(window.location.pathname && window.location.pathname.indexOf("/private-report/")>=0){
			   
			   return(
				   <Route path="/" component={Pages} />
				)
		  }else{
			  return(
				   <div className={`${user && user.role && Array.isArray(user.role) ? user.role.join(" ") : ""}`}>
					  <Layout />
					  <div className="container__wrap">
					  	
						<Route path="/" component={Pages} />
					
						<div className="disclaimer">
						
						Marketproof, Inc. &copy; {new Date().getFullYear()}
						{` `} |  {` `}
						<a href="https://marketproof.com/terms-of-use" target="_blank">Terms of Service</a>
						{` `} |  {` `}
						<a href="https://marketproof.com/privacy-policy" target="_blank">Privacy Policy</a>
						
						</div> 
					  </div>
				   </div>
			  )
		  }
		   
	       
		     
		}else{
			if(window.location.pathname && window.location.pathname != "/login"){
				setLocalStorage("mp", "redirect", window.location.pathname);
			}
			
			return <Redirect to={{ pathname: `/learn-more` }} />;
		}

	
 }
}

export default connect(state => ({
  user: state.user,
  dataSet : state.buyersLists.dataSet
}))(withOktaAuth(wrappedRoutes));
